<template>
  <div class="container">
    <v-row>
      <v-col cols="12">
        <PeriodCollege_assistantcommittee/>
      </v-col>
      <v-col cols="12">
        <Assistantcommittee_proposal />
      </v-col>
      <v-col cols="12">
      <Assistantcommitteequalified_ass/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Assistantcommittee_proposal from "../../../components/admin/assistantcommittee_proposal.vue";
import Assistantcommitteequalified_ass from "../../../components/admin/assistantcommitteequalified_ass.vue";
import PeriodCollege_assistantcommittee from "../../../components/admin/periodCollege_assistantcommittee.vue";

export default {
  name: "AssistantCommitteeQualified",
  components: {
    PeriodCollege_assistantcommittee,
    Assistantcommittee_proposal,
    Assistantcommitteequalified_ass
  },
  data() {
    return {
      // Add your data properties here
    };
  },
  computed: {
    // Add computed properties here
  },
  methods: {
    // Add methods here
  },
  mounted() {
    // Add lifecycle hooks here
  }
};
</script>

<style scoped>
/* Add your styles here */
</style>
